<template>
  <q-page class="container" padding>
    <div class="row title align col-12 q-mb-md text-brand-5 text-weight-bold">
      <q-icon @click="voltar" size="sm" name="arrow_back_ios" />

      <p class="text-h6 text-brand-5 text-weight-bold">
        Detalhes da Transferencia
      </p>
    </div>

    <div class="row q-mt-sm q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2">
        Estoque de Origem
        <q-input dense outlined v-model="dados.origem.nome" :disable="true" />
      </div>
      <div class="col-md-2">
        Estoque de Destino
        <q-input dense outlined v-model="dados.destino" :disable="true" />
      </div>
      <div class="col-md-2">
        ID da Trasnferencia
        <q-input dense outlined v-model="dados.numero" :disable="true" />
      </div>
      <div class="col-md-2">
        Nome do Requisitante
        <q-input dense outlined v-model="dados.requisitante" :disable="true" />
      </div>
      <div
        v-if="dados.solicitante && dados.solicitante.usuario != null"
        class="col-md-2"
      >
        Nome do Solicitante
        <q-input
          dense
          outlined
          v-model="dados.solicitante.usuario.nome"
          :disable="true"
        />
      </div>

      <div v-else-if="dados.solicitante" class="col-md-2">
        Nome do Solicitante
        <q-input
          dense
          outlined
          v-model="dados.solicitante.nome"
          :disable="true"
        />
      </div>
      <div v-if="dados.status == 'criada'" class="col-md-3">
        <p></p>
        <q-btn
          flat
          style="color: red"
          icon="delete"
          no-caps
          dense
          class="q-mt-sm"
          label="Excluir a Transferência"
          @click="excluir = true"
        />
      </div>
      <div v-if="dados.status == 'enviada'" class="col-md-3">
        <p></p>
        <q-btn
          flat
          style="color: red"
          icon="delete"
          no-caps
          dense
          class="q-mt-sm"
          label="Cancelar a Transferência"
          @click="excluir = true"
        />
      </div>
    </div>

    <div class="row q-gutter-sm q-mt-lg text-brand-5 text-weight-bold">
      <div
        v-if="dados.solicitante && dados.solicitante.usuario != null"
        class="col-md-2"
      >
        Setor Solicitante
        <q-input
          dense
          outlined
          v-model="dados.solicitante.usuario.ghe"
          :disable="true"
        />
      </div>
      <div class="col-md-2">
        Status Atual
        <q-input dense outlined v-model="dados.status" :disable="true" />
      </div>
      <div v-if="dados.status == 'criada'">
        <p></p>
        <q-btn
          color="green-6"
          icon="check_circle_outline"
          no-caps
          dense
          class="q-mt-sm"
          label="Enviar Transferência"
          @click="enviar = true"
        />
      </div>
      <div v-if="dados.status == 'enviada'">
        <p></p>
        <q-btn
          color="secondary"
          icon="done"
          no-caps
          dense
          class="q-mt-sm"
          label="Receber Transferência"
          @click="receber = true"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          color="primary"
          icon="print"
          no-caps
          dense
          class="q-mt-sm"
          label="Imprimir"
          @click="imprimir"
        />
      </div>
      <div class="q-ml-sm">
        <p></p>
        <q-btn
          v-if="
            dados.status == 'cancelada' ||
            (dados.status == 'enviada' && dados.rejeicao != null)
          "
          color="red"
          icon-right="send"
          no-caps
          dense
          class="q-mt-sm"
          label="Origem da Rejeição"
          @click="origem"
        />
      </div>
    </div>

    <div class="row col-12 q-mt-xl">
      <p class="text-h6 self-end text-brand-5 text-weight-bold">Enviar Anexo</p>
    </div>

    <div class="row col-12 q-mt-md q-pb-lg q-gutter-sm">
      <div class="col-md-2 col-sm-12 col-xs-12">
        <q-file
          class="q-mt-md"
          bg-color="primary"
          label-color="white"
          style="margin-top: 22px"
          dense
          outlined
          v-model="file"
          label="Selecionar Arquivo"
        >
          <template v-slot:prepend>
            <q-icon name="file_upload" />
          </template>
        </q-file>
      </div>
      <div class="col-md-2 col-sm-8 col-xs-8 text-brand-5 text-weight-bold">
        Descrição do Anexo

        <input type="text" class="comentarioUP" />
      </div>
      <div class="col-md-3 col-sm-8 col-xs-8">
        <p></p>
        <q-btn
          class="q-mt-sm"
          color="green-6"
          label="Enviar Documento"
          no-caps
          dense
          icon="check_circle_outline"
          @click="uploadTransferencia"
        />
      </div>
    </div>

    <div class="col-md-2 col-sm-8 col-xs-8 q-mb-md">
      <q-btn
        class="q-mt-lg"
        color="primary"
        label="Anexos Enviados"
        icon="attach_file"
        no-caps
        @click="documentosList = true"
      />
    </div>

    <q-dialog v-model="documentosList">
      <q-card style="width: 800px; max-width: 80vw">
        <q-card-section class="row justify-center">
          <div class="text-h6 text-grey-6">Anexos Enviados</div>
        </q-card-section>

        <div class="column q-mt-md">
          <div
            class="column q-mt-md justify-center"
            v-for="(document, index) in dados.documento"
            :key="index"
          >
            <span class="q-ml-sm q-mt-sm q-mb-sm"
              >Documento {{ index + 1 }}</span
            >
            <div class="row">
              <span class="q-ml-sm" style="width: 45%"
                >Descrição: {{ document.comentario }}</span
              >
              <div style="width: 50%">
                <q-btn
                  dense
                  color="green-6"
                  type="a"
                  icon="file_download"
                  no-caps
                  :label="`Baixar Anexo`"
                  :href="document.urlAssinada"
                  target="_blank"
                />
                <q-btn
                  dense
                  flat
                  no-caps
                  icon="delete"
                  class="q-ml-sm"
                  color="red"
                  @click="excluirDocumento(document.uuid)"
                  :label="`Excluir Anexo`"
                />
              </div>
            </div>
            <q-separator />
          </div>
        </div>
      </q-card>
    </q-dialog>

    <div class="row col-12 q-mt-xl q-ml-md">
      <p class="text-h6 self-end text-brand-5 text-weight-bold">
        Ferramentas que estão sendo transferidas:
      </p>
    </div>

    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="ferramentasSelecionadas"
      :columns="columns"
      dense
      class="tabela-tamanho-fixo"
      row-key="name"
      :rows-per-page-options="[0]"
      hide-bottom
    >
      <template #body-cell-selecionado="props">
        <q-td>
          <q-btn
            size="sm"
            color="grey-5"
            icon="check_circle_outline"
            label="Selecionado"
            no-caps
            :disable="true"
            @click="emitir(props.row.uuid)"
          />
        </q-td>
      </template>

      <template #body-cell-codigo="props">
        <q-td>
          {{ props.row.nome }}
        </q-td>
      </template>
      <template #body-cell-descricao="props">
        <q-td>
          {{ props.row.descricao }}
        </q-td>
      </template>
      <template #body-cell-patrimonio="props">
        <q-td>
          {{ props.row.patrimonio }}
        </q-td>
      </template>
      <template v-if="dados.status == 'criada'" #body-cell-remover="props">
        <q-td>
          <q-btn
            flat
            style="color: red"
            label="Remover"
            icon="remove_circle_outline"
            no-caps
            @click="removerFerramenta(props.row.uuid)"
          />
        </q-td>
      </template>
    </q-table>

    <table-transferencia-ferramenta
      v-if="dados.status == 'criada' && dados.origem.id"
      @selecionados="receberSelecionados"
      :escolhidas="ferramentasSelecionadas"
      :unidadeId="dados.origem.id"
    />

    <q-dialog v-model="receber">
      <q-card style="width: 800px; max-width: 80vw">
        <q-card-section v-if="dados.status == 'criada'">
          <div class="text-h6">Excluir transferência</div>
        </q-card-section>
        <q-card-section v-if="dados.status == 'enviada'">
          <div class="text-h5">Rejeitar transferência</div>
        </q-card-section>
        <q-separator />
        <p class="size q-pl-sm q-pt-sm">
          Selecione as ferramentas que deseja rejeitar. As ferramentas
          selecionadas vão ser inseridas em outra transferência e irão retornar
          para a origem
        </p>
        <div
          class="row align"
          v-for="(ferramenta, index) in ferramentasSelecionadas"
          :key="index"
        >
          <q-checkbox
            size="sm"
            v-model="ferramentasRegeitar"
            :val="ferramenta.uuid"
            @click="verificarAvisoRejeicao(ferramenta.uuid)"
          />

          <p><strong class="q-pl-xs">Código:</strong> {{ ferramenta.nome }},</p>
          <p>
            <strong class="q-pl-xs">Descrição: </strong>
            {{ ferramenta.descricao }},
          </p>
          <p>
            <strong class="q-pl-xs">Patrimonio:</strong>
            {{ ferramenta.patrimonio }}
          </p>
        </div>
        <q-input
          class="q-pt-md"
          dense
          outlined
          v-model="observacao3"
          label="Digite sua observação aqui"
          type="textarea"
        />
        <q-btn
          class="q-mt-sm"
          style="width: 100%"
          color="red"
          label="Receber"
          @click="receberTransferencia"
        />
      </q-card>
    </q-dialog>

    <q-dialog v-model="avisoRejeicao">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">Aviso</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <span class="text-bold text-red"
            >A TRANSFERÊNCIA SERÁ REJEITADA, TEM CERTEZA?</span
          >
        </q-card-section>

        <q-card-actions class="row col-12 justify-between">
          <q-btn
            flat
            label="Cancelar"
            no-caps
            color="red"
            v-close-popup
            @click="removerFerramentaRejeicao()"
          />
          <q-btn flat label="OK" no-caps color="positive" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="excluir">
      <q-card style="width: 800px; max-width: 80vw">
        <q-card-section
          class="row justify-center"
          v-if="dados.status == 'criada'"
        >
          <div class="text-h6">
            Deseja <span class="text-red">excluir</span> a transferência?
          </div>
        </q-card-section>
        <q-card-section
          class="row justify-center"
          v-if="dados.status == 'enviada'"
        >
          <div class="text-h6">
            Deseja <span class="text-red">Cancelar</span> transferencia
          </div>
        </q-card-section>
        <div class="q-ml-sm">Digite sua observação</div>
        <q-input
          class="q-pt-md"
          dense
          outlined
          v-model="observacao2"
          label="Digite sua observação aqui"
          type="textarea"
        />
        <div class="row justify-end">
          <q-btn
            flat
            no-caps
            icon="delete"
            v-if="dados.status == 'criada'"
            class="q-mt-sm"
            color="red"
            label="Excluir Transferência"
            @click="excluirTransferencia"
          />
          <q-btn
            flat
            no-caps
            v-if="dados.status == 'enviada'"
            class="q-mt-sm"
            color="red"
            label="Cancelar Transferência"
            @click="cancelarTransferencia"
          />
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="enviar">
      <q-card style="width: 800px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Enviar transferencia</div>
        </q-card-section>
        <q-separator />
        <q-card-section class="row align">
          <p>Dados Solicitante</p>
          <q-radio v-model="responsavelForm" val="sou" label="Sou cadastrado" />
          <q-radio
            v-model="responsavelForm"
            val="nao"
            label="Não sou cadastrado"
          />
        </q-card-section>

        <div class="column">
          <div class="row q-pt-sm q-pb-sm">
            <q-input
              class="q-pl-sm"
              v-if="responsavelForm == 'nao'"
              dense
              outlined
              v-model="solicitante.solicitante_nome"
              label="Solicitante Nome"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            <q-input
              class="q-pl-sm"
              v-if="responsavelForm == 'nao'"
              dense
              outlined
              v-model="solicitante.solicitante_matricula"
              label="Solicitante Matricula"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            {{}}
            <select-component-responsaveis
              v-if="responsavelForm == 'sou'"
              :label="'Responsavel'"
              @emitirFuncionario="receberDadosSolicitante"
            />
          </div>
          <q-separator />
          <q-card-section class="row align">
            <p>Dados Expedidor</p>
            <q-radio v-model="expedidorForm" val="sou" label="Sou cadastrado" />
            <q-radio
              v-model="expedidorForm"
              val="nao"
              label="Não sou cadastrado"
            />
          </q-card-section>

          <div class="row q-pt-sm q-pb-sm">
            <q-input
              class="q-pl-sm"
              dense
              v-if="expedidorForm == 'nao'"
              outlined
              v-model="expedidor.expedidor_nome"
              label="Expedidor Nome"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            <q-input
              class="q-pl-sm"
              v-if="expedidorForm == 'nao'"
              dense
              outlined
              v-model="expedidor.expedidor_matricula"
              label="Expedidor Matricula"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />

            <select-component-responsaveis
              v-if="expedidorForm == 'sou'"
              :label="'Expedidor'"
              @emitirFuncionario="receberDadosExpedidor"
            />
          </div>
          <q-separator />

          <q-card-section>
            <p class="text-h7">Dados Transporte</p>
          </q-card-section>

          <div class="row q-pt-sm">
            <q-input
              class="q-pl-sm"
              dense
              outlined
              v-model="transportador.transportador_nome"
              label="Transporte Nome"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            <q-input
              class="q-pl-sm"
              dense
              outlined
              v-model="transportador.transportador_matricula"
              label="Transporte Matricula"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            <q-input
              class="q-pl-sm"
              dense
              outlined
              v-model="transportador.veiculo_placa"
              label="Veiculo Placa"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
            <q-input
              class="q-pl-sm q-pt-sm"
              dense
              outlined
              v-model="transportador.veiculo_modelo"
              label="Veiculo Modelo"
              :rules="[(val) => !!val || 'Campo Obrigatorio']"
            />
          </div>
        </div>

        <q-input
          class="q-pt-md"
          dense
          outlined
          v-model="observacao"
          label="Digite sua observação aqui"
          :rules="[(val) => !!val || 'Campo Obrigatorio']"
          type="textarea"
        />
        <q-separator />
        <q-btn
          class="q-mt-sm"
          style="width: 100%"
          color="primary"
          label="Enviar"
          @click="enviarTransferencia"
        />
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "selecionado",
    label: "Selecionado",
    field: "descricao",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    field: "nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    field: "patrimonio",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { ref, onMounted } from "vue";
//import { useStore } from "vuex";
import { useQuasar } from "quasar";
//import SelectUnidades from "../components/SelectUnidades.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import TableTransferenciaFerramenta from "../components/TableTransferenciaFerramenta.vue";

import SelectComponentResponsaveis from "../components/SelectFuncionario.vue";

export default {
  name: "trasnferenciaFerramentas",
  components: {
    TableTransferenciaFerramenta,
    SelectComponentResponsaveis,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const $q = useQuasar();
    let enviar = ref(false);
    const observacao3 = ref("");
    const id = route.params.id;
    const descricaoDocumento = ref("");
    const observacao = ref("");
    const observacao2 = ref("");
    const mudarStatus = ref("");
    const ferramentasRegeitar = ref([]);
    const excluir = ref(false);
    const receber = ref(false);
    const transferenciaData = ref("");
    const file = ref(null);
    const documentosList = ref(false);
    const ferramentasSelecionadas = ref([]);
    const solicitante = ref({
      solicitante_nome: "",
      solicitante_matricula: "",
      solicitante_id: "",
    });
    const expedidor = ref({
      expedidor_nome: "",
      expedidor_matricula: "",
      expedidor_id: "",
    });
    const transportador = ref({
      transportador_nome: "",
      transportador_matricula: "",
      veiculo_placa: "",
      veiculo_modelo: "",
    });
    const dados = ref({
      origem: "",
      destino: "",
      numero: "",
      requisitante: "",
      solicitante: "",
      setor: "",
      status: "",
      documento: "",
      rejeicao: "",
    });
    let avisoRejeicao = ref(false);
    const idFerramentaRejeicao = ref("");

    const getTransferencia = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("fer/getDetalheTransferencia", {
          id,
        });

        ferramentasSelecionadas.value = response.data.itens.ferramentas;
        dados.value.status = response.data.status;
        dados.value.requisitante = response.data.requisitante.usuario.nome;
        dados.value.numero = response.data.numero;
        dados.value.origem = response.data.unidadeOrigem.unidade;
        dados.value.destino = response.data.unidadeDestino.unidade.nome;
        dados.value.solicitante = response.data.solicitante;
        dados.value.setor = response.data.requisitante.usuario.ghe;
        dados.value.documento = response.data.documentos;
        dados.value.rejeicao = response.data.origemRejeicaoUuid;
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar detalhes da transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getTransferencia);

    const receberSelecionados = async (value) => {
      let modify = { uuid: value };
      let adicionadarFerramentas = [];

      adicionadarFerramentas.push(modify);

      try {
        await store.dispatch("fer/adicionarFerramentas", {
          ferramentas: adicionadarFerramentas,
          id,
        });
        $q.notify({
          message: "Ferramenta adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Ferramenta ja Selecionada, ou não encontrada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerFerramenta = async (value) => {
      let modify = { uuid: value };
      let removerFerramentas = [];

      removerFerramentas.push(modify);
      try {
        await store.dispatch("fer/removerFerramentas", {
          ferramentas: removerFerramentas,
          id,
        });
        $q.notify({
          message: "Ferramenta removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao remover ferramenta",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = async () => {
      router.push({ name: "trasnferenciaFerramentas" });
    };

    const enviarTransferencia = async () => {
      if (
        observacao.value == "" ||
        transportador.value.transportador_nome == "" ||
        transportador.value.transportador_matricula == "" ||
        transportador.value.veiculo_placa == "" ||
        transportador.value.veiculo_modelo == ""
      ) {
        $q.notify({
          message: "Preecha os campos obrigatorios",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        await store.dispatch("fer/enviarTransferencia", {
          solicitante_nome: solicitante.value.solicitante_nome,
          solicitante_matricula: solicitante.value.solicitante_matricula,
          solicitante_id: solicitante.value.solicitante_id,
          expedidor_nome: expedidor.value.expedidor_nome,
          expedidor_matricula: expedidor.value.expedidor_matricula,
          expedidor_id: expedidor.value.expedidor_id,
          transportador_nome: transportador.value.transportador_nome,
          transportador_matricula: transportador.value.transportador_matricula,
          veiculo_placa: transportador.value.veiculo_placa,
          veiculo_modelo: transportador.value.veiculo_modelo,
          observacao: observacao.value,
          id,
        });
        $q.notify({
          message: "Enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        enviar.value = false;
        getTransferencia();
      } catch (error) {
        $q.notify({
          message:
            "Erro ao enviar transferencia, preencha os campos obrigatorios",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirTransferencia = async () => {
      try {
        await store.dispatch("fer/excluirTransferencia", {
          observacao: observacao2.value,
          id,
        });
        $q.notify({
          message: "Transferencia excluida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "trasnferenciaFerramentas" });
      } catch (error) {
        $q.notify({
          message: "Erro ao excluir transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const cancelarTransferencia = async () => {
      try {
        await store.dispatch("fer/cancelarTransferencia", {
          observacao: observacao2.value,
          id,
        });
        $q.notify({
          message: "Transferencia cancelada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        excluir.value = false;
        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao cancelar transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const uploadTransferencia = async () => {
      if (file.value == null || file.value == "null") {
        $q.notify({
          message: "Selecione alguma planilha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          let comentario = await document.querySelector(".comentarioUP").value;

          await store.dispatch("fer/uploadTransferencia", {
            id,
            comentario: comentario,
            documento: reader.result,
          });
        };

        reader.onerror = function (error) {
          console.log("Error: ", error);
        };

        $q.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        file.value = null;
        descricaoDocumento.value = "";
        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberTransferencia = async () => {
      let array = [];

      ferramentasRegeitar.value.forEach((e) => {
        array.push({ uuid: e });
      });

      try {
        await store.dispatch("fer/receberTransferencia", {
          observacao: observacao3.value,
          id,
          rejeitadas: array,
        });
        $q.notify({
          message: "Transferencia recebida com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receber.value = false;
        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao recebida transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      getTransferencia();
    };

    const receberDadosSolicitante = async (value) => {
      solicitante.value.solicitante_id = value.value.id;
    };

    const receberDadosExpedidor = async (value) => {
      expedidor.value.expedidor_id = value.value.id;
    };

    const excluirDocumento = async (uuid) => {
      try {
        await store.dispatch("fer/excluirDocumento", {
          documento: uuid,
          id,
        });
        $q.notify({
          message: "Documento excluido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        getTransferencia();
      } catch (error) {
        $q.notify({
          message: "Erro ao excluir documento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const imprimir = async () => {
      router.push({ name: "imprimirTransferencia", params: { id: id } });
    };

    const origem = async () => {
      try {
        let response = await store.dispatch("fer/getDetalheTransferencia", {
          id: dados.value.rejeicao,
        });

        ferramentasSelecionadas.value = response.data.itens.ferramentas;
        dados.value.status = response.data.status;
        dados.value.requisitante = response.data.requisitante.usuario.nome;
        dados.value.numero = response.data.numero;
        dados.value.origem = response.data.unidadeOrigem.unidade.nome;
        dados.value.destino = response.data.unidadeDestino.unidade.nome;
        dados.value.solicitante = response.data.solicitante;
        dados.value.setor = response.data.requisitante.usuario.ghe;
        dados.value.documento = response.data.documentos;
        dados.value.rejeicao = response.data.origemRejeicaoUuid;
      } catch (error) {
        $q.notify({
          message: "Erro ao encontrar detalhes da transferencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarAvisoRejeicao = (id) => {
      idFerramentaRejeicao.value = id;
      ferramentasRegeitar.value.some((ferramenta) => {
        if (ferramenta == id) {
          avisoRejeicao.value = true;
        }
      });
    };

    const removerFerramentaRejeicao = () => {
      ferramentasRegeitar.value = ferramentasRegeitar.value.filter(
        (ferramenta) => ferramenta != idFerramentaRejeicao.value
      );
    };

    return {
      observacao,
      id,
      voltar,
      dados,
      descricaoDocumento,
      mudarStatus,
      getTransferencia,
      transferenciaData,
      file,
      columns,
      ferramentasSelecionadas,
      receberSelecionados,
      removerFerramenta,
      enviar,
      solicitante,
      expedidor,
      transportador,
      responsavelForm: ref("sou"),
      expedidorForm: ref("sou"),
      documentosList,
      enviarTransferencia,
      excluirTransferencia,
      excluir,
      observacao2,
      cancelarTransferencia,
      uploadTransferencia,
      receberTransferencia,
      receber,
      observacao3,
      ferramentasRegeitar,
      receberDadosSolicitante,
      receberDadosExpedidor,
      excluirDocumento,
      imprimir,
      origem,
      avisoRejeicao,
      verificarAvisoRejeicao,
      removerFerramentaRejeicao,
      idFerramentaRejeicao,
    };
  },
};
</script>

<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
a {
  text-decoration: none;
}

.align {
  align-items: center;
}

.align p {
  margin: 0;
}

.title p {
  margin: 0 !important;
}

.title i {
  cursor: pointer;
  margin: 0px 0px 3px 0px;
}

.comentarioUP {
  width: 100%;
  height: 40px;

  outline-color: #58afc1;
}

.size {
  font-size: 16px;
}
</style>
